import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormOctagon"><Path d="M16.3613 2.21973L21.7803 7.63867L22 7.85742V16.1426L21.7803 16.3613L16.3613 21.7803L16.1426 22H7.85742L7.63867 21.7803L2.21973 16.3613L2 16.1426V7.85742L2.21973 7.63867L7.63867 2.21973L7.85742 2H16.1426L16.3613 2.21973Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
